import React from 'react';
import { Button, withStyles } from '@material-ui/core';

const styles = (theme) => ({
  container: {
    display: 'flex',
    border: `1px solid ${theme.shadowColor}`,
    borderRadius: 5,
    overflow: 'hidden',
    width: 'fit-content'
  },
  button: {
    width: 120,
    color: theme.gridTextColor,
    borderRadius: 0,
    fontWeight: 500,
    border: 'none',
    boxShadow: 'none',
    padding: 0
  },
  activeButton: {
    backgroundColor: theme.gridHeaderBGColor,
    color: theme.palette.primary.main,
    fontWeight: 600
  }
});

const ToggleButton = ({ isPercentage, setIsPercentage, classes }) => {
  return (
    <div className={classes.container}>
      <Button
        variant={isPercentage ? 'contained' : 'outlined'}
        disableElevation
        onClick={() => setIsPercentage(true)}
        className={`${classes.button} ${isPercentage ? classes.activeButton : ''}`}>
        Percentages
      </Button>
      <Button
        variant={!isPercentage ? 'contained' : 'outlined'}
        disableElevation
        onClick={() => setIsPercentage(false)}
        className={`${classes.button} ${!isPercentage ? classes.activeButton : ''}`}>
        Aggregated
      </Button>
    </div>
  );
};

export default withStyles(styles)(ToggleButton);
